export const saveVideoSpecAsDraft = 'saveVideoSpecAsDraft';
export const navigateToPage = 'navigateToPage';
